<template>
  <div class="shift-template-manager">
    <el-button type="primary" @click="openDialog()">Создать шаблон</el-button>

    <el-table :data="templates" style="width: 80%">
      <el-table-column prop="name" label="Название" />
      <el-table-column prop="pattern" label="Паттерн">
        <template #default="scope">
          {{ getPatternLabel(scope.row.pattern) }}
        </template>
      </el-table-column>
      <el-table-column label="Перерывы" width="250">
        <template #default="scope">
          <div v-for="(br, i) in scope.row.breaks" :key="i">
            {{ getBreakIcon(br.type) }} {{ br.start_time }}–{{ br.end_time }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Действия" align="right" width="150">
        <template #default="scope">
          <el-button size="small" type="primary" :icon="EditPen" @click="openDialog(scope.row)"/>
          <el-button size="small" type="danger" :icon="Delete" :loading="deletingId === scope.row.id" @click="confirmRemoveTemplate(scope.row)"/>
        </template>
      </el-table-column>

      <template #empty>
        <div class="empty-table">
          Пока нет шаблонов. Нажмите "Создать шаблон", чтобы добавить первый.
        </div>
      </template>
    </el-table>

    <el-dialog v-model="dialogVisible" title="Шаблон смены" width="500px">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="0">
        <el-form-item prop="name">
          <el-input v-model="form.name" placeholder="Название шаблона" />
        </el-form-item>
        <el-form-item prop="pattern">
          <el-select v-model="form.pattern" placeholder="Паттерн">
            <el-option label="5/2 (пн–пт, сб–вс выходные)" value="5_2" />
            <el-option label="2/2 (2 рабочих, 2 выходных)" value="2_2" />
            <el-option label="3/3 (3 рабочих, 3 выходных)" value="3_3" />
            <el-option label="1/3 (сутки через трое)" value="1_3" />
            <el-option label="1/2 (сутки через двое)" value="1_2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="breaks-container">
            <el-button
              type="success"
              size="small"
              @click="addBreak"
              class="break-add-btn">
              Добавить перерыв
            </el-button>
            <div class="break-row">
              <template v-for="(br, idx) in form.breaks" :key="idx">
                <el-select v-model="br.type" placeholder="Тип перерыва" class="break-select">
                  <el-option label="Обед" value="lunch" />
                  <el-option label="Перерыв" value="break" />
                  <el-option label="Тех.перерыв" value="maintenance" />
                  <el-option label="Смена" value="handover" />
                </el-select>
                <el-time-select v-model="br.start_time" :start="'00:00'" :end="'23:59'" step="00:15" placeholder="Начало" class="break-time" />
                <el-time-select v-model="br.end_time" :start="br.start_time || '00:00'" :end="'23:59'" step="00:15" placeholder="Конец" class="break-time" />
                <el-button type="danger" :icon="Delete" circle @click="confirmRemoveBreak(idx)" />
              </template>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">Отмена</el-button>
        <el-button type="primary" @click="saveTemplate">Сохранить</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Delete, Edit, EditPen } from '@element-plus/icons-vue'
import { mapActions } from 'vuex'

export default {
  name: "ShiftTemplateManager",
  computed: {
    EditPen() {
      return EditPen
    },
    Edit() {
      return Edit
    },
    Delete() {
      return Delete
    },
    templates() {
      return this.$store.state.schedules.schedulesTemplates || []
    }
  },
  props: {
    modelValue: { type: Array, default: () => [] }
  },
  data() {
    return {
      dialogVisible: false,
      form: { id: null, name: "", pattern: "", breaks: [] },
      rules: {
        name: [
          { required: true, message: 'Пожалуйста, введите название шаблона', trigger: 'blur' }
        ],
        pattern: [
          { required: true, message: 'Пожалуйста, выберите паттерн', trigger: 'change' }
        ],
      },
      deletingId: null,
    }
  },
  methods: {
    ...mapActions('schedules', ['fetchScheduleTemplates', 'saveScheduleTemplate', 'deleteScheduleTemplates']),
    getBreakIcon(type) {
      switch (type) {
        case "lunch": return "🍽️"
        case "break": return "⏸️"
        case "maintenance": return "🛠️"
        case "handover": return "🔁"
        default: return "⏹️"
      }
    },
    openDialog(template = null) {
      this.form = template
        ? JSON.parse(JSON.stringify(template))
        : { id: null, name: "", pattern: "", breaks: [] }
      this.dialogVisible = true
    },
    async saveTemplate() {
      await this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        await this.saveScheduleTemplate(this.form)
        this.$message.success('Шаблон сохранён')
        this.dialogVisible = false
      })
    },
    async confirmRemoveTemplate(row) {
      try {
        await this.$confirm('Удалить этот шаблон?', 'Подтверждение', {
          confirmButtonText: 'Удалить',
          cancelButtonText: 'Отмена',
          type: 'warning',
        })
        this.deletingId = row.id
        await this.deleteScheduleTemplates(row.id)
        this.$message.success('Шаблон удалён')
      } catch (e) {
        // cancelled or failed — do nothing
      } finally {
        this.deletingId = null
      }
    },
    confirmRemoveBreak(idx) {
      this.$confirm('Удалить этот перерыв?', 'Подтверждение', {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        type: 'warning',
      }).then(() => {
        this.form.breaks.splice(idx, 1)
      }).catch(() => {})
    },
    async removeTemplate(id) {
      await this.deleteScheduleTemplates(id);
    },
    getPatternLabel(value) {
      switch (value) {
        case "5_2": return "5/2 (пн–пт, сб–вс выходные)"
        case "2_2": return "2/2 (2 рабочих, 2 выходных)"
        case "3_3": return "3/3 (3 рабочих, 3 выходных)"
        case "1_3": return "1/3 (сутки через трое)"
        case "1_2": return "1/2 (сутки через двое)"
        default: return value
      }
    },
    addBreak() {
      // Проверяем только на "обед"
      const existingLunch = this.form.breaks.some(b => b.type === 'lunch')
      if (existingLunch) {
        // Если добавляется ещё один lunch — предупреждаем
        this.form.breaks.push({ type: 'break', start_time: '', end_time: '' })
        return
      }
      // По умолчанию добавляем lunch первым, если его ещё нет
      this.form.breaks.push({ type: 'lunch', start_time: '', end_time: '' })
    }
  },
  mounted() {
    this.fetchScheduleTemplates()
  }
}
</script>

<style scoped>
.breaks-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  padding: 8px 0;
  max-width: 100%;
}

/* Make .break-row take full width and distribute columns */
.break-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 6px;
  align-items: center;
  width: 100%;
}

.break-select {
  /* Remove min-width and max-width, expand to grid cell */
  width: 100%;
}

.break-time {
  /* Remove min-width and max-width, expand to grid cell */
  width: 100%;
}

.break-add-btn {
  align-self: flex-start;
}

.empty-table {
  text-align: center;
  padding: 20px;
  color: #888;
}
</style>
